
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#50585B","stroke-width":"1.1","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M15.604 12.43h6.286m3.113-4.21a3.134 3.134 0 00-6.265 0v7.05c0 2.594-.538 5.51-3.134 5.51h9.399M12.483 24.991c-6.261-8.348-6.261-17.196 0-23.979M2.458 18.737H13.52M2.458 7.261H13.52M1 12.476h12.52"}}),_c('path',{attrs:{"d":"M13 25C6.372 25 1 19.628 1 13S6.372 1 13 1h.522v24H13z"}})])])
          )
        }
      }
    